import { __extends, __assign } from 'tslib';
import React__default from 'react';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator.component.js';
import { propTypes, defaultProps } from './LoadingOverlay.types.js';
import styles from './LoadingOverlay.module.scss.js';

var LoadingOverlay = /** @class */ (function (_super) {
    __extends(LoadingOverlay, _super);
    function LoadingOverlay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingOverlay.prototype.render = function () {
        var _a = this.props, hasBackgroundBlur = _a.hasBackgroundBlur, greyAnimation = _a.greyAnimation, className = _a.className, spinnerClassName = _a.spinnerClassName, size = _a.size;
        return (React__default.createElement("div", { className: styles.LoadingOverlay + " " + (className || '') + " " + (hasBackgroundBlur ? styles.LoadingOverlay___blurred : '') },
            React__default.createElement(LoadingIndicator, { greyAnimation: greyAnimation, className: spinnerClassName || '', size: size })));
    };
    LoadingOverlay.displayName = 'LoadingOverlay';
    LoadingOverlay.propTypes = propTypes;
    LoadingOverlay.defaultProps = __assign({}, defaultProps);
    return LoadingOverlay;
}(React__default.Component));

export default LoadingOverlay;
